import { create } from 'zustand';

import { GetCredits } from '../api';

import { resetCreditsPage } from './use-credits-pagination-store';
import { omit } from '@/utils';

type GetCreditsParam = GetCredits['param'];

export type UseCreditsFilterStore = {
  userId: string;
  searchString: GetCreditsParam['searchString'];
  status: GetCreditsParam['status'];
};

const defaultValue: UseCreditsFilterStore = {
  userId: '',
  searchString: '',
  status: [],
};

export const useCreditsFilterStore = create<UseCreditsFilterStore>(() => ({
  ...defaultValue,
}));

export const useSearchFilter = () =>
  useCreditsFilterStore((state) => state.searchString);

export const useStatusFilter = () =>
  useCreditsFilterStore((state) => state.status);

export const useCreditsFilter = () => useCreditsFilterStore((state) => state);

export const setSearchStringFilter = (
  searchString: UseCreditsFilterStore['searchString'],
) => {
  useCreditsFilterStore.setState({ searchString });
  resetCreditsPage();
};

export const setStatusFilter = (status: UseCreditsFilterStore['status']) => {
  useCreditsFilterStore.setState({ status });
  resetCreditsPage();
};

export const resetHiddenFilters = () => {
  useCreditsFilterStore.setState({
    ...omit(defaultValue, ['searchString']),
  });
};

export const resetCreditsFilterStore = () => {
  useCreditsFilterStore.setState({ ...defaultValue });
  resetCreditsPage();
};
